import {
  ApiSyntheticCalculationType,
  IApiNewSyntheticSymbol,
  IApiSymbol,
  IApiSyntheticSymbol,
  IApiSyntheticSymbolDetails,
} from '@cbridge-packages/api';
import { ScheduleTranslator } from '@cbridge-packages/schedule';
import type { ISourceSymbol, ISyntheticSymbol, ISyntheticSymbolDetails, ISyntheticSymbolForm } from './symbolSynthetic.interface';

export namespace SymbolSyntheticTranslator {
  export function fromApi(symbol: IApiSyntheticSymbol): ISyntheticSymbol {
    return {
      symbolId: symbol.id,
      symbolGroup: symbol.symbolGroup,
      name: symbol.name,
      calculationType: symbol.calculationType,
      sourceSymbol1Id: symbol.sourceSymbol1?.id,
      sourceSymbol1Name: symbol.sourceSymbol1?.name,
      sourceSymbol2Id: symbol.sourceSymbol2?.id,
      sourceSymbol2Name: symbol.sourceSymbol2?.name,
      baseAsset: symbol.baseAsset,
      quoteAsset: symbol.quoteAsset,
      priceDigits: symbol.priceDigits,
      scheduleId: symbol.schedule?.id,
      scheduleName: symbol.schedule?.name,
    };
  }

  export function fromApiDetails(symbol: IApiSyntheticSymbolDetails): ISyntheticSymbolDetails {
    const result: ISyntheticSymbolDetails = fromApi({ ...symbol, schedule: symbol.schedule });
    result.schedule = symbol.schedule && ScheduleTranslator.fromApiFullView(symbol.schedule);

    return result;
  }

  export function toSourceSymbol(symbol: IApiSymbol): ISourceSymbol {
    return {
      symbolId: symbol.id,
      name: symbol.name,
      symbolGroup: symbol.symbolGroup,
      baseAsset: symbol.baseAsset,
      quoteAsset: symbol.quoteAsset,
    };
  }

  export function toApi(symbol: Partial<ISyntheticSymbolForm>): IApiNewSyntheticSymbol {
    const isTriangulation = symbol.calculationType === ApiSyntheticCalculationType.Triangulation;

    return {
      symbolGroup: symbol.symbolGroup,
      name: symbol.name,
      calculationType: symbol.calculationType,
      sourceSymbol1Id: symbol.sourceSymbol1Id,
      sourceSymbol2Id: isTriangulation ? symbol.sourceSymbol2Id : undefined,
      baseAsset: symbol.baseAsset,
      quoteAsset: symbol.quoteAsset,
      priceDigits: symbol.priceDigits,
      scheduleId: symbol.scheduleId,
    };
  }
}
